"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS = void 0;
const theme_1 = require("../theme");
const theme_palette_1 = require("../theme.palette");
exports.CSS = {
    alertHref: 'c-Page__alert-href',
    closeButton: 'c-Page__CloseButton',
    alert: 'c-Page__alert',
    closeIcon: 'c-Page__CloseIcon',
    message: 'c-Page__message'
};
const alertHeightDesktop = 36;
const alertHeightLaptop = 60;
const alertHeightMobile = 84;
const Style = {
    [exports.CSS.closeButton]: {
        position: 'absolute',
        right: theme_1.DefaultTheme.space(1),
        color: theme_palette_1.ColorPalette2022Branding.darkGray,
        background: 'none',
        padding: theme_1.DefaultTheme.space(1.5),
        border: `1px solid ${theme_palette_1.ColorPalette2022Branding.darkGray}`,
        borderRadius: '2px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        ['&:hover']: {
            color: theme_palette_1.ColorPalette2022Branding.g11,
            borderColor: theme_palette_1.ColorPalette2022Branding.g11
        }
    },
    [exports.CSS.alertHref]: {
        textDecoration: 'underline',
        color: theme_palette_1.ColorPalette2022Branding.lightIndigo,
        ['&:hover']: {
            color: theme_palette_1.ColorPalette2022Branding.lightGray
        }
    },
    [exports.CSS.alert]: {
        height: `${alertHeightDesktop}px`,
        backgroundColor: theme_palette_1.ColorPalette2022Branding.ikeOrange,
        color: theme_palette_1.ColorPalette2022Branding.darkGray,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        padding: '0 12px',
        ['@media only screen and (max-width: 1200px)']: {
            height: `${alertHeightLaptop}px`
        },
        ['@media only screen and (max-width: 700px)']: {
            height: `${alertHeightMobile}px`
        }
    },
    [`${exports.CSS.alert} a`]: {
        transition: 'color 0.15s ease'
    },
    [exports.CSS.closeIcon]: {
        fontSize: '16px'
    },
    [exports.CSS.message]: {
        'padding-right': '70px'
    }
};
(0, theme_1.addStyles)(Style);
//# sourceMappingURL=message.banner.style.js.map